import * as React from 'react';

interface OwnProps {
    className?: string;
    count: number;
}

/**
 * Cervene koliesko v strede s vycentrovanym bielym textom
 *
 * (pouzivame svg pretoze vie vycentrovat text presnejsie ako css-kova verzia)
 */
export class CountBadge extends React.Component<OwnProps> {

    public render() {
        const { className, count } = this.props;

        return (
            <svg className={className} viewBox="0 0 100 100">
                <g id="UrTavla">
                    <circle
                        fill="#ee0728"
                        stroke="white"
                        strokeWidth="10"
                        cx="50"
                        cy="50"
                        r="45"
                    />

                    {/* <rect x="15" y="15" width="70" height="70" fill="yellow" stroke="none" /> */}

                    <text
                      x="50"
                      y="50"
                      stroke="none"
                      fill="white"
                      textAnchor="middle"
                      textLength="64"
                      fontSize="60"
                      fontWeight="bold"
                      dominantBaseline="central"
                      lengthAdjust="spacing"
                    >
                        {count}
                    </text>
                </g>
            </svg>
        );
    }
}
